<template>
  <a-card :bordered='false'>
    <a-form ref='form' :model='search' class="m-b-20" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="提交人" name='keyword'>
        <a-input v-model:value="search.keyword" style="width:250px" placeholder="请输入名称/手机号" />
      </a-form-item>
      <a-form-item label="提交任务" name='group_task_id'>
        <a-input v-model:value="search.group_task_id" style="width:250px" placeholder="请输入任务ID" />
      </a-form-item>
      <a-form-item label="经销商" name='apply_name'>
        <a-input placeholder="选择经销商" style="width: 200px;" readonly v-model:value="search.apply_name"></a-input>
        <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 13px;" v-if='search.apply_name' @click='search.apply_name="";' />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="visible=true">选择</a-button>
      </a-form-item>
      <a-form-item label="奖励状态" name='send_status'>
        <a-select v-model:value="search.send_status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="2">未发放</a-select-option>
          <a-select-option :value="1">已发放</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class='tableFixBox' :scroll="{ x: 'max-content'}">
      <template v-slot:action="{ record }">
        <a-button v-if="record.send_status!=1" type="link" size="small" v-has:delargrant="()=>delargrant(record)">发放</a-button>
        <p v-else>-</p>
      </template>
          <template v-slot:submit_name="{ record }">
        <p>{{record.submit_name}}</p>
        <p>({{record.submit_phone}})</p>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  <a-modal title="选择经销商" v-model:visible="visible" centered :width='1200' destroyOnClose :footer="null">
    <selectDealer :isSubDealer="true" v-on:select="dealerSelect" :mustShowHeadquarters='false'></selectDealer>
  </a-modal>
</template>
<script>
import { CloseCircleFilled } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getexamineList,editargran } from "@/api/guide";
import { iscode } from "@/utils/app";
import { qrcanvas } from "qrcanvas";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  apply_type: 1,
  keyword: "",
  apply_name: "",
  send_status: "",
  is_awards:1,
};
export default {
  components: {
    CloseCircleFilled,
  },
  setup() {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      visible: false,
      listLoading: false,
      total: 0,
    });
    let columns = [
      {
        title: "提交人",
        dataIndex: "submit_name",
        key: "submit_name",
            slots: { customRender: "submit_name" },
      },
      {
        title: "经销商名称",
        dataIndex: "apply_name",
        key: "apply_name",
        customRender: ({ record }) => {
          return record.apply_name ? record.apply_name : "-";
        },
      },
      {
        title: "奖励状态",
        dataIndex: "send_status_text",
        key: "send_status_text",
      },
      {
        title: "提交任务（ID）",
        dataIndex: "group_task_id",
        key: "group_task_id",
      },
      {
        title: "操作",
        key: "action",
        width: 100,
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    //发放
    const delargrant = async (e) => {
      let res = await editargran({ id:e.id})
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        initData();
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    };
    //经销商选择
    const dealerSelect = (data) => {
      search.value.apply_name = data.dealer_name;
      state.visible = false;
    };
    const initData = async () => {
      state.listLoading = true;
      let res = await getexamineList({ ...search.value })
        .then((res) => res.data)
        .catch((error) => error);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data.data;
        state.total = res.data.total;
      } else {
        message.error(res.message);
      }
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      initData,
      dealerSelect,
      delargrant,
    };
  },
};
</script>
<style>
.ant-table td {
  white-space: nowrap;
}
</style>